import { ThemeOptions } from "@mui/material/styles";

declare module "@mui/material/styles" {
  interface ZIndex {
    CCAutocomplete: number;
    PdpDeliverySection:number;
    scrollUpButton:number;
    pdpVideoPlayer:number;
  }

  interface ZIndexOptions {
    CCAutocomplete?: number;
    PdpDeliverySection?:number;
    scrollUpButton:number;
    pdpVideoPlayer?:number;
  }
}

export const zIndex: ThemeOptions = {
    zIndex: {
        appBar: 1100,
        drawer: 1300,
        modal: 1300,
        tooltip: 1400,
        PdpDeliverySection:1300,
        CCAutocomplete: 1301,
        scrollUpButton: 1401,
        pdpVideoPlayer:1402
  },
};

